import { V2BannerUpdateRequestDtoCategory as BannerCategory, V2BannerUpdateRequestDtoLinkType as LinkType, V2BannerUpdateRequestDtoPositionsItem as PositionsItem } from "@everon-it/api-client/contents-gw";
import { type BannerCommonContentsOptionType, type BannerCreateInitValuesType } from "@pages/BannerCreate/Data";
import { CommonElementType } from "@utils/DynamicComponentUtils";
import { type CommonCreateBodyKeyType, type CommonDataType } from "src/types/common";

export type BannerDetailInitValuesType = BannerCreateInitValuesType;

export const BannerDetailData: CommonDataType<CommonCreateBodyKeyType, BannerDetailInitValuesType, BannerCommonContentsOptionType> = {
    createBodyKey: ["category", "displayStartAt", "displayEndAt", "isVisible", "title", "imageUrl", "linkType", "linkTargetId", "uuid", "linkUrl", "displayOrder", "positions"],
    formInitialValues: {
        category: BannerCategory.POPUP,
        displayStartAt: "",
        displayEndAt: "",
        isVisible: false,
        title: "",
        imageUrl: "",
        linkType: LinkType.NOTICE,
        linkTargetId: null,
        linkUrl: "",
        displayOrder: 0,
        positions: [],
    },
    contentsOption: [
        {
            label: "배너종류",
            name: "category",
            type: CommonElementType.RADIO,
            options: [
                { label: "토스트 팝업", value: BannerCategory.POPUP },
                { label: "띠 배너", value: BannerCategory.BANNER },
            ],
        },
        {
            label: "분류",
            name: "positions",
            type: CommonElementType.CHECK_BOX,
            hasKeywordToShowContent: BannerCategory.BANNER,
            options: [
                { label: "전체", value: "ALL" },
                { label: "홈", value: PositionsItem.MAIN },
                { label: "포인트 충전하기", value: PositionsItem.PREPAID },
                { label: "충전권 선물하기", value: PositionsItem.GIFT },
            ],
        },
        {
            label: "게시 기간",
            name: "displayStartAt",
            secondName: "displayEndAt",
            type: CommonElementType.DATE_RANGE_PICKER,
            placeholder: "날짜를 입력해주세요",
            secondPlaceholder: "날짜를 입력해주세요",
        },
        {
            label: "노출 상태",
            name: "isVisible",
            type: CommonElementType.TOGGLE,
        },
        {
            label: "제목(관리자용)",
            name: "title",
            type: CommonElementType.INPUT,
            placeholder: "팝업 제목을 입력해주세요",
        },
        {
            label: "팝업 이미지",
            name: "imageUrl",
            type: CommonElementType.IMAGE_UPLOAD,
            size: "large",
            isSizeQuestion: true,
        },
    ],
};
